<template>
	<div
		class="seo-hidden"
		style="display: none !important; visibility: hidden !important">
		<h1>{{ seoTitle }} | IMME</h1>
		<p class="lead">{{ seoDescription }}</p>
		<p>{{ seoCanonical }}</p>
	</div>
</template>

<script>
	export default {
		name: "SeoComponent",

		props: {
			seoTitle: String,
			seoDescription: String,
			seoCanonical: String,
			seoImage: String,
		},

		data() {
			return {
				path: {
					base_url: process.env.VUE_APP_BASE_URL,
					endpoint: process.env.VUE_APP_ENDPOINT,
					storage_files: process.env.VUE_APP_STORAGE_FILES,
				},
				cfg: {
					category: this.$route.meta.cfgCategory,
					nameCategory: this.$route.meta.cfgNameCategory,
				},
			};
		},

		metaInfo() {
			return {
				title: this.seoTitle,
				htmlAttrs: {
					lang: "es-mx",
				},
				meta: [
					{ name: "description", content: this.seoDescription },
					{ name: "robots", content: "index,follow" },
					{ name: "revisit-after", content: "1 days" },
					{ "http-equiv": "expires", content: "43200" },
					{ "http-equiv": "language", content: "es-mx" },
					{
						property: "og:title",
						content: this.seoTitle,
						template: (chunk) => `${chunk} | IME`,
					},
					{ property: "og:type", content: "article" },
					{ property: "og:description", content: this.seoDescription },
					{
						property: "og:url",
						content: this.seoCanonical,
					},
					{ property: "og:image", content: this.seoImage },
					{
						name: "twitter:title",
						content: this.seoTitle,
						template: (chunk) => `${chunk} | IME`,
					},
					{ name: "twitter:card", content: this.seoDescription },
					{
						name: "twitter:url",
						content: this.seoCanonical,
					},
					{ name: "twitter:image", content: this.seoImage },
					{ name: "msapplication-TileColor", content: "#691c32" },
					{ name: "theme-color", content: "#235b4e" },
				],
			};
		},

		mounted() {
			this.track();
		},

		methods: {
			track() {
				this.$gtag.pageview({ page_title: this.seoTitle + " | IMME" });
				this.$gtag.pageview({
					page_location: this.path.base_url + "/" + this.seoCanonical,
				});
			},
		},
	};
</script>
